module.exports = __webpack_public_path__ + "static/media/img113.3ecf2e95.jpg";